import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const CekResi = () => {
  const [nomorResi, setNomorResi] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (nomorResi.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Nomor resi tidak boleh kosong!",
        confirmButtonColor: "#0d9488",
        customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
      });
      return;
    }

    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/lacak_pengiriman",
        {
          tracking_id: nomorResi,
        }
      );

      const data = response.data;

      if (response.status !== 200) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.error || "Terjadi kesalahan.",
          confirmButtonColor: "#0d9488",
        });
        return;
      }

      // Menampilkan hasil pengiriman dalam bentuk pop-up Swal modern & rapi
      Swal.fire({
        title: `<div class="text-center pt-2 pb-2 border-bottom"><h4 class="fw-bold m-0" style="color: #0d9488; font-family: 'Poppins', sans-serif;"><i class="fa fa-shipping-fast me-2"></i>Detail Pengiriman</h4></div>`,
        html: `
          <div class="text-start mt-3" style="font-size: 0.9rem; font-family: 'Poppins', sans-serif; color: #374151; max-height: 65vh; overflow-y: auto; padding-right: 4px;">
            
            <!-- Grid Informasi Utama -->
            <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 14px; background: #f8fafc; padding: 18px; border-radius: 14px; margin-bottom: 20px; border: 1px solid #e2e8f0;">
              <div>
                <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Tracking ID</span>
                <span style="font-family: monospace; font-weight: 700; color: #0d9488; font-size: 1rem;">${data.tracking_id || "-"}</span>
              </div>
              <div>
                <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Nama Petani</span>
                <span style="font-weight: 600; color: #1e293b; text-transform: capitalize;">${data.nama_petani || "-"}</span>
              </div>
              <div>
                <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Tanggal Pengiriman</span>
                <span style="color: #475569; font-size: 0.85rem;">${data.tanggal_pengiriman || "-"}</span>
              </div>
              <div>
                <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Tanggal Diterima</span>
                <span style="color: #475569; font-size: 0.85rem;">${data.tanggal_diterima || "-"}</span>
              </div>
              <div>
                <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Pabrik Tujuan</span>
                <span style="font-weight: 600; color: #1e293b;">${data.Pabrik_tujuan || "-"}</span>
              </div>
              <div>
                <span style="font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; display: block; margin-bottom: 2px;">Muatan Sawit (Awal / Akhir)</span>
                <span style="font-family: monospace; font-weight: 600; color: #1e293b;">${data.berat_sawit_awal || "-"} kg / ${data.berat_sawit_akhir || "-"} kg</span>
              </div>
            </div>

            <!-- Informasi Logistik -->
            <h6 class="fw-bold mb-2" style="font-size: 0.95rem; color: #0f766e;">Informasi Logistik & Armada</h6>
            <div class="table-responsive border rounded-3 overflow-hidden">
              <table class="table table-sm table-striped mb-0 align-middle" style="font-size: 12px;">
                <thead class="table-light">
                  <tr>
                    <th class="py-2 px-3 fw-semibold">Logistik</th>
                    <th class="py-2 px-3 fw-semibold text-center">Status</th>
                    <th class="py-2 px-3 fw-semibold">Lokasi</th>
                    <th class="py-2 px-3 fw-semibold">Driver</th>
                    <th class="py-2 px-3 fw-semibold">Plat Truk</th>
                  </tr>
                </thead>
                <tbody>
                  ${
                    data.logistik_info && data.logistik_info.length > 0
                      ? data.logistik_info
                          .map((logistik) => {
                            const status = logistik.status_Pengiriman || "Pending";
                            let badgeClass = "bg-warning-subtle text-warning-emphasis border-warning-subtle";
                            if (status.toLowerCase().includes("delivered") || status.toLowerCase().includes("selesai")) {
                              badgeClass = "bg-success-subtle text-success border-success-subtle";
                            } else if (status.toLowerCase().includes("transit") || status.toLowerCase().includes("pengiriman")) {
                              badgeClass = "bg-primary-subtle text-primary border-primary-subtle";
                            }

                            // Menambahkan titik (bullet) pada Lokasi, Driver, dan Plat Truk
                            const lokasiList = logistik.drivers && logistik.drivers.length > 0
                              ? logistik.drivers.map((d) => `<div class="mb-1">• ${d.lokasi || "-"}</div>`).join("")
                              : "-";

                            const driverList = logistik.drivers && logistik.drivers.length > 0
                              ? logistik.drivers.map((d) => `<div class="mb-1">• ${d.nama_driver || "-"}</div>`).join("")
                              : "-";

                            const platList = logistik.drivers && logistik.drivers.length > 0
                              ? logistik.drivers.map((d) => `<div class="mb-1 font-monospace">• ${d.plat_truk || "-"}</div>`).join("")
                              : "-";

                            return `
                            <tr>
                              <td class="py-2 px-3 fw-medium">${logistik.logistik || "-"}</td>
                              <td class="py-2 px-3 text-center">
                                <span class="badge ${badgeClass} border px-2 py-1 rounded-pill fw-semibold" style="font-size: 10px;">
                                  ${status}
                                </span>
                              </td>
                              <td class="py-2 px-3 text-secondary">${lokasiList}</td>
                              <td class="py-2 px-3 fw-medium">${driverList}</td>
                              <td class="py-2 px-3">${platList}</td>
                            </tr>
                          `;
                          })
                          .join("")
                      : `<tr><td colspan="5" class="text-center py-3 text-muted fst-italic">Tidak ada informasi logistik</td></tr>`
                  }
                </tbody>
              </table>
            </div>

          </div>
        `,
        width: "800px",
        background: "#ffffff",
        confirmButtonText: "Tutup",
        confirmButtonColor: "#0d9488",
        showCloseButton: true,
        focusConfirm: false,
        customClass: {
          popup: "rounded-4 shadow-lg border-0 p-4",
          confirmButton: "rounded-pill px-4 fw-bold shadow-sm",
        },
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pengiriman tidak ditemukan.",
        confirmButtonColor: "#0d9488",
        customClass: { confirmButton: "rounded-pill px-4 fw-bold" },
      });
    }
  };

  return (
    <Container
      fluid
      id="cekResiSection"
      className="py-5"
      style={{ backgroundColor: "#28dbcf", minHeight: "350px", display: "flex", alignItems: "center" }}
    >
      <Row className="justify-content-center w-100 m-0">
        <Col xs={12} className="mb-3">
          <h1
            className="text-center fw-bold text-white"
            style={{ fontFamily: "Poppins, sans-serif", letterSpacing: "0.5px" }}
          >
            Cek Resi Pengiriman
          </h1>
          <p className="text-center text-white opacity-75 small">
            Masukkan nomor tracking ID Anda untuk melacak status perjalanan sawit secara real-time.
          </p>
        </Col>

        <Col xs={11} sm={8} md={6} lg={5}>
          <Form onSubmit={handleSubmit} className="p-4 rounded-4 shadow-sm bg-white border">
            <Form.Group className="mb-3 text-start" controlId="nomorResi">
              <Form.Label
                className="fw-bold text-secondary mb-2"
                style={{ fontSize: "0.95rem", fontFamily: "Poppins, sans-serif" }}
              >
                Nomor Resi / Tracking ID
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Contoh: SAWIT5934430"
                value={nomorResi}
                onChange={(e) => setNomorResi(e.target.value)}
                required
                className="shadow-none rounded-3 py-2 px-3"
                style={{ borderColor: "#cbd5e1", fontSize: "0.95rem" }}
              />
            </Form.Group>

            <div className="text-center">
              <Button
                type="submit"
                className="w-100 shadow-sm fw-bold py-2 rounded-pill text-uppercase"
                style={{
                  backgroundColor: "#0d9488",
                  borderColor: "#0d9488",
                  letterSpacing: "0.5px",
                }}
              >
                Cek Resi Sekarang
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default CekResi;